// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import UserMenuController from "./user_menu_controller"
application.register("user-menu", UserMenuController)

import AsyncStyleController from "./async_style_controller"
application.register("async-style", AsyncStyleController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import DashboardFormController from "./dashboard_form_controller"
application.register("dashboard-form", DashboardFormController)

import FilterFormController from "./filter_form_controller"
application.register("filter-form", FilterFormController)

import LoadingController from "./loading_controller"
application.register("loading", LoadingController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import OauthPopupController from "./oauth_popup_controller"
application.register("oauth-popup", OauthPopupController)

import SlackOauthCallbackController from "./slack_oauth_callback_controller"
application.register("slack-oauth-callback", SlackOauthCallbackController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import WebhookTestController from "./webhook_test_controller"
application.register("webhook-test", WebhookTestController)
